import { action } from '@/lib/api.js';
import { store } from '@/redux/lib/configureStore.js';
import setQuery from '@/lib/setQuery.js';
import { query } from '@/redux/selectors/querySelectors';
import buildWorkflowStepSelectionQuery from '@/screens/workflows/lib/buildWorkflowStepSelectionQuery.js';
import getWorkflowStepTabQueryKey from '@/screens/workflows/lib/getWorkflowStepTabQueryKey.js';

const setActiveSteps = ({ steps = [], clear = false, replace }) => {
  const state = store.getState();
  const selectedSteps = state?.workflow?.selectedSteps;
  const stepId = query(state, 'stepId');
  const stepTab = query(state, 'stepTab');

  const noChange = steps?.join('|') === selectedSteps?.join('|') && selectedSteps?.includes(stepId);
  if (noChange) {
    return;
  }

  if (steps?.length < 1 && !clear) {
    return;
  }

  action('SET_WORKFLOW_SELECTED_STEPS', steps);
  const newStepId = steps?.length !== 1 ? null : steps?.[0];
  if (newStepId === stepId) {
    return;
  }

  const nextStepTab = newStepId ? query(state, getWorkflowStepTabQueryKey({ stepId: newStepId })) : null;
  const queryValues = buildWorkflowStepSelectionQuery({
    currentStepId: stepId,
    currentStepTab: stepTab,
    nextStepId: newStepId,
    nextStepTab
  });

  setQuery(queryValues, replace === undefined ? undefined : { replace });
};

export default setActiveSteps;
